import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-952c14a8")

_pushScopeId("data-v-952c14a8")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { style: {"text-align":"center"} }
const _hoisted_4 = { class: "image is-128x128 img-center" }
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = { "data-testid": "profile-username" }
const _hoisted_7 = { class: "align-right margin-t-24" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fas fa-key" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Change your password ")
const _hoisted_10 = {
  key: 0,
  class: "display-center"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("div", {
  class: "box-red-border margin-t-24",
  "data-testid": "profile-empty-description"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-exclamation-circle is-red" }),
  /*#__PURE__*/_createTextVNode(" Enhance your chances of meeting new teammates by completing your profile. ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = { class: "columns is-desktop" }
const _hoisted_14 = { class: "column is-three-fifths-desktop" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "diplay-inline margin-b-24" }, [
  /*#__PURE__*/_createVNode("h4", { class: "title is-4 diplay-inline" }, "Description"),
  /*#__PURE__*/_createTextVNode(" (visible to all users) max 100 char ")
], -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_17 = {
  key: 0,
  class: "fas fa-check-circle is-green"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("h4", { class: "title is-4 diplay-inline" }, " Skill ", -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_20 = {
  key: 1,
  class: "fas fa-check-circle is-green diplay-inline"
}
const _hoisted_21 = { class: "box shadow" }
const _hoisted_22 = { class: "columns" }
const _hoisted_23 = { class: "column is-half" }
const _hoisted_24 = { class: "field is-grouped padding-0-15" }
const _hoisted_25 = { class: "control is-expanded" }
const _hoisted_26 = { class: "dropdown-trigger full-width" }
const _hoisted_27 = {
  class: "dropdown-menu full-width",
  id: "dropdown-menu",
  role: "menu"
}
const _hoisted_28 = {
  key: 0,
  class: "dropdown-content shadow select-style"
}
const _hoisted_29 = {
  key: 0,
  class: "dropdown-item align-center",
  "data-testid": "profile-dropdown-noresult"
}
const _hoisted_30 = {
  key: 1,
  class: "dropdown-content shadow select-style"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("p", { class: "dropdown-item align-center" }, " Loading... ", -1)
const _hoisted_32 = { class: "control" }
const _hoisted_33 = /*#__PURE__*/_createVNode("p", { class: "margin-b-24" }, " Put your skill tags in order of strength, the first 1 will be displayed on your profil card. ", -1)
const _hoisted_34 = {
  key: 0,
  class: "box-white-border is-8-min-height-em "
}
const _hoisted_35 = /*#__PURE__*/_createVNode("i", { class: "fas fa-xs fa-times diplay-inline language-img pointer " }, null, -1)
const _hoisted_36 = {
  key: 1,
  class: "box-white-border is-8-min-height-em display-center",
  "data-testid": "profile-empty-skills"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "column is-1" }, null, -1)
const _hoisted_38 = { class: "column" }
const _hoisted_39 = /*#__PURE__*/_createVNode("h4", { class: "title is-4 diplay-inline" }, "Level", -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_41 = {
  key: 0,
  class: "fas fa-check-circle is-green diplay-inline"
}
const _hoisted_42 = { class: "box shadow" }
const _hoisted_43 = { class: "select" }
const _hoisted_44 = /*#__PURE__*/_createVNode("h4", { class: "title is-4" }, "CTF", -1)
const _hoisted_45 = { class: "box shadow" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = {
  key: 1,
  class: "align-center",
  "data-testid": "profile-empty-ctf"
}
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" You have not yet registered for a CTF ")
const _hoisted_49 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("button", {
  class: "button select-style",
  "data-testid": "profile-ctf-discover-btn"
}, " Discover ", -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("h4", { class: "title is-4 diplay-inline" }, "Language", -1)
const _hoisted_53 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_54 = {
  key: 0,
  class: "fas fa-check-circle is-green diplay-inline"
}
const _hoisted_55 = { class: "box shadow" }
const _hoisted_56 = { class: "select margin-b-24" }
const _hoisted_57 = { class: "margin-b-24" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { class: "image is-16x16 diplay-inline " }
const _hoisted_60 = /*#__PURE__*/_createVNode("i", { class: "fas fa-xs fa-times diplay-inline language-img pointer" }, null, -1)
const _hoisted_61 = {
  key: 1,
  class: "align-center",
  "data-testid": "profile-empty-language"
}
const _hoisted_62 = /*#__PURE__*/_createVNode("div", { class: "modal-background" }, null, -1)
const _hoisted_63 = { class: "modal-card width-300" }
const _hoisted_64 = { class: "modal-card-body modal-style-popup" }
const _hoisted_65 = /*#__PURE__*/_createVNode("h6", { class: "title is-6 margin-10" }, "Your profile", -1)
const _hoisted_66 = /*#__PURE__*/_createVNode("div", { class: "margin-10" }, " Fill your description to find more teammates! ", -1)
const _hoisted_67 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_68 = { class: "modal-card" }
const _hoisted_69 = { class: "modal-card-head modal-style" }
const _hoisted_70 = /*#__PURE__*/_createVNode("p", { class: "modal-card-title is-white" }, "CHANGE YOUR PASSWORD", -1)
const _hoisted_71 = { class: "modal-card-body modal-style" }
const _hoisted_72 = { class: "field field-margin" }
const _hoisted_73 = { class: "control has-icons-left" }
const _hoisted_74 = /*#__PURE__*/_createVNode("span", { class: "icon is-left" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-lock" })
], -1)
const _hoisted_75 = { class: "field field-margin" }
const _hoisted_76 = { class: "control has-icons-left" }
const _hoisted_77 = /*#__PURE__*/_createVNode("span", { class: "icon is-left" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-lock" })
], -1)
const _hoisted_78 = { class: "field field-margin" }
const _hoisted_79 = { class: "control has-icons-left" }
const _hoisted_80 = /*#__PURE__*/_createVNode("span", { class: "icon is-left" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-lock" })
], -1)
const _hoisted_81 = {
  key: 0,
  class: "help is-danger"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("figure", _hoisted_4, [
          (_ctx.link != null)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                class: "is-rounded",
                src: _ctx.link
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_5,
        _createVNode("b", _hoisted_6, _toDisplayString(_ctx.user.username), 1)
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isChangePasswordActive = true)),
          class: "button button-style is-small margin-5"
        }, [
          _hoisted_8,
          _hoisted_9
        ])
      ]),
      (_ctx.user.description == '')
        ? (_openBlock(), _createBlock("div", _hoisted_10, [
            _hoisted_11
          ]))
        : _createCommentVNode("", true),
      _hoisted_12,
      _createVNode("div", _hoisted_13, [
        _createVNode("div", _hoisted_14, [
          _hoisted_15,
          _hoisted_16,
          (_ctx.fieldUpdated.includes('description'))
            ? (_openBlock(), _createBlock("i", _hoisted_17))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode("textarea", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.description = $event)),
            maxlength: "100",
            onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateProfile('description'))),
            class: "textarea shadow is-white is-background-light-black margin-b-24",
            "data-testid": "profile-description",
            placeholder: "Tell us about your story"
          }, null, 544), [
            [_vModelText, _ctx.description]
          ]),
          _hoisted_18,
          _hoisted_19,
          (_ctx.fieldUpdated.includes('skill'))
            ? (_openBlock(), _createBlock("i", _hoisted_20))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_21, [
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, [
                _createVNode("div", _hoisted_24, [
                  _createVNode("div", _hoisted_25, [
                    _createVNode("div", {
                      class: 'dropdown full-width ' + _ctx.dropdownIsActive
                    }, [
                      _createVNode("div", _hoisted_26, [
                        _withDirectives(_createVNode("input", {
                          class: "input is-white is-background-light-black padding-right-8",
                          type: "search",
                          maxlength: "20",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchedTags = $event)),
                          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.dropdownIsActive = 'is-active'), ["stop"])),
                          placeholder: "Add your skill",
                          "data-testid": "profile-input-skills"
                        }, null, 512), [
                          [_vModelText, _ctx.searchedTags]
                        ])
                      ]),
                      _createVNode("div", _hoisted_27, [
                        (!_ctx.tagLoading)
                          ? (_openBlock(), _createBlock("div", _hoisted_28, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.findSearchedTags(), (tag) => {
                                return (_openBlock(), _createBlock("a", {
                                  class: "dropdown-item",
                                  key: tag,
                                  onClick: ($event: any) => (_ctx.searchedTags = tag.name),
                                  "data-testid": "profile-dropdown-item-skills"
                                }, _toDisplayString(tag.name), 9, ["onClick"]))
                              }), 128)),
                              (_ctx.findSearchedTags().length === 0)
                                ? (_openBlock(), _createBlock("p", _hoisted_29, " No result "))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_30, [
                              _hoisted_31
                            ]))
                      ])
                    ], 2)
                  ]),
                  _createVNode("p", _hoisted_32, [
                    _createVNode("a", {
                      class: "button is-background-green no-border",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addSkills && _ctx.addSkills(...args))),
                      "data-testid": "profile-add-skills"
                    }, " Add ")
                  ])
                ])
              ])
            ]),
            _hoisted_33,
            (_ctx.skills.length > 0 && !_ctx.tagLoading)
              ? (_openBlock(), _createBlock("div", _hoisted_34, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.skills, (tag) => {
                    return (_openBlock(), _createBlock("span", {
                      class: "custom-tag-profile",
                      key: tag,
                      style: { backgroundColor: _ctx.findTagColor(tag) },
                      "data-testid": "profile-skills"
                    }, [
                      _createTextVNode(_toDisplayString(tag.replace(" ", " ")) + " ", 1),
                      _createVNode("div", {
                        class: "diplay-inline ",
                        onClick: ($event: any) => (_ctx.removeSkills(tag)),
                        "data-testid": "profile-delete-skills"
                      }, [
                        _hoisted_35
                      ], 8, ["onClick"])
                    ], 4))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_36, " You have not yet filled in your Skills "))
          ])
        ]),
        _hoisted_37,
        _createVNode("div", _hoisted_38, [
          _hoisted_39,
          _hoisted_40,
          (_ctx.fieldUpdated.includes('level'))
            ? (_openBlock(), _createBlock("i", _hoisted_41))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_42, [
            _createVNode("div", _hoisted_43, [
              _withDirectives(_createVNode("select", {
                class: "select-style",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.level = $event)),
                onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateProfile('level'))),
                "data-testid": "profile-select-level"
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.arrayOfLevel, (level) => {
                  return (_openBlock(), _createBlock("option", {
                    key: level,
                    value: level
                  }, _toDisplayString(level), 9, ["value"]))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.level]
              ])
            ])
          ]),
          _hoisted_44,
          _createVNode("div", _hoisted_45, [
            (_ctx.user.ctfs.length > 0 && !_ctx.ctfLoading)
              ? (_openBlock(), _createBlock("div", _hoisted_46, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.user.ctfs, (ctfId) => {
                    return (_openBlock(), _createBlock("span", {
                      class: "box-white-border margin-ctf-name diplay-inline pointer",
                      key: ctfId,
                      "data-testid": "profile-ctf",
                      onClick: ($event: any) => (_ctx.route('/ctf/' + ctfId))
                    }, _toDisplayString(_ctx.findCtfById(ctfId)), 9, ["onClick"]))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_47, [
                  _hoisted_48,
                  _hoisted_49,
                  _hoisted_50,
                  _createVNode(_component_router_link, { to: "/" }, {
                    default: _withId(() => [
                      _hoisted_51
                    ]),
                    _: 1
                  })
                ]))
          ]),
          _createVNode("div", null, [
            _hoisted_52,
            _hoisted_53,
            (_ctx.fieldUpdated.includes('language'))
              ? (_openBlock(), _createBlock("i", _hoisted_54))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_55, [
              _createVNode("div", _hoisted_56, [
                _createVNode("select", {
                  class: "select-style",
                  onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.addLanguage && _ctx.addLanguage(...args))),
                  "data-testid": "profile-language-select"
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.arrayOfCountry, (language) => {
                    return (_openBlock(), _createBlock("option", {
                      key: language,
                      value: language
                    }, _toDisplayString(language), 9, ["value"]))
                  }), 128))
                ], 32)
              ]),
              _createVNode("div", _hoisted_57, [
                (_ctx.language.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_58, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.language, (l) => {
                        return (_openBlock(), _createBlock("div", {
                          key: l,
                          class: "box-white-border language-box"
                        }, [
                          _createVNode("figure", _hoisted_59, [
                            _createVNode("img", {
                              class: "is-rounded ",
                              src: `/img/flag-country/${l}.png`
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("div", {
                            class: "display-inherit",
                            onClick: ($event: any) => (_ctx.removeLanguage(l)),
                            "data-testid": "profile-delete-language"
                          }, [
                            _hoisted_60
                          ], 8, ["onClick"])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_61, " You have not yet selected a language "))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", {
      class: `modal ${_ctx.currentStep == 5 ? 'is-active' : ''}`
    }, [
      _hoisted_62,
      _createVNode("div", _hoisted_63, [
        _createVNode("section", _hoisted_64, [
          _hoisted_65,
          _hoisted_66,
          _createVNode("div", null, [
            _createVNode("a", {
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.prevAction && _ctx.prevAction(...args))),
              class: "button is-small is-primary is-outlined",
              "data-testid": "modal-previous-button"
            }, " PREVIOUS STEP "),
            _hoisted_67,
            _createVNode("a", {
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.finishTour && _ctx.finishTour(...args))),
              class: "button is-small is-background-black no-border is-white",
              "data-testid": "modal-finish-button"
            }, " FINISH TOUR ")
          ])
        ])
      ])
    ], 2),
    _createVNode("div", {
      class: `modal ${_ctx.isChangePasswordActive ? 'is-active' : ''}`
    }, [
      _createVNode("div", {
        class: "modal-background",
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isChangePasswordActive = false))
      }),
      _createVNode("div", _hoisted_68, [
        _createVNode("header", _hoisted_69, [
          _hoisted_70,
          _createVNode("button", {
            class: "delete border-solid",
            "aria-label": "close",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isChangePasswordActive = false))
          })
        ]),
        _createVNode("section", _hoisted_71, [
          _createVNode("div", _hoisted_72, [
            _createVNode("div", _hoisted_73, [
              _withDirectives(_createVNode("input", {
                placeholder: "Old Password",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.oldPassword = $event)),
                class: 
                  `input is-background-black is-white ' ${
                    _ctx.error != '' ? 'is-danger' : ''
                  }`
                ,
                type: "password"
              }, null, 2), [
                [_vModelText, _ctx.oldPassword]
              ]),
              _hoisted_74
            ])
          ]),
          _createVNode("div", _hoisted_75, [
            _createVNode("div", _hoisted_76, [
              _withDirectives(_createVNode("input", {
                placeholder: "New Password",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.newPassword = $event)),
                class: 
                  `input is-background-black is-white ' ${
                    _ctx.error != '' ? 'is-danger' : ''
                  }`
                ,
                type: "password"
              }, null, 2), [
                [_vModelText, _ctx.newPassword]
              ]),
              _hoisted_77
            ])
          ]),
          _createVNode("div", _hoisted_78, [
            _createVNode("div", _hoisted_79, [
              _withDirectives(_createVNode("input", {
                placeholder: "Repeat your password",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.newBisPassword = $event)),
                class: 
                  `input is-background-black is-white ' ${
                    _ctx.error != '' ? 'is-danger' : ''
                  }`
                ,
                type: "password"
              }, null, 2), [
                [_vModelText, _ctx.newBisPassword]
              ]),
              _hoisted_80
            ])
          ]),
          (_ctx.error != '')
            ? (_openBlock(), _createBlock("p", _hoisted_81, _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true),
          _createVNode("button", {
            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.sendPasswordChange && _ctx.sendPasswordChange(...args))),
            class: "button is-background-green no-border margin-t-24"
          }, " SAVE CHANGES ")
        ])
      ])
    ], 2)
  ]))
})